export default __webpack_public_path__ + "static/media/5_active.84e51497.png";